import CommonPersonalSettingHome from '../../../common/pages/secure/PersonalSettingHome'

class PersonalSettingHome extends CommonPersonalSettingHome {
  constructor (props) {
    super(props)
    this.state = {}
    this.userRoleUrl = 'admin'
  }
}

export default PersonalSettingHome



// WEBPACK FOOTER //
// ./src/admin/pages/secure/PersonalSettingHome.js